import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { UserService } from '../../../services/user.service';
import { SettingsService } from '../../../services/settings.service';

@UntilDestroy()
@Component({
  selector: 'app-user-settings-language',
  templateUrl: './user-settings-language.component.html',
  styleUrls: ['./user-settings-language.component.scss'],
})
export class UserSettingsLanguageComponent implements OnInit {
  @Input() isMobile = false;
  @Input() PANELS;
  @Output() goBack = new EventEmitter<any>();

  isTimezoneAuto?: boolean;
  timezoneName?: string;

  constructor(
    private translateService: TranslateService,
    private userService: UserService,
    private settingsService: SettingsService,
  ) {}

  ngOnInit(): void {
    this.userService.user.pipe(untilDestroyed(this)).subscribe((res) => {
      const user = res?.user;
      if (user) {
        this.isTimezoneAuto = user.timezone.autoDetect;
        this.timezoneName = user.timezone.value;
      }
    });
  }

  toggleAuto(value: boolean): void {
    this.saveTimezone(value);
  }

  async saveTimezone(auto = true): Promise<void> {
    const udpateTimezoneArg = auto ? undefined : this.timezoneName;
    await this.userService.updateTimezone(udpateTimezoneArg);
    this.settingsService.showToast({
      title: this.translateService.instant('Timezone updated'),
    });
  }

  handleTimezoneSelect(timezoneID: string): void {
    const isTimezoneUpdated = this.timezoneName !== timezoneID;
    this.timezoneName = timezoneID;
    if (isTimezoneUpdated) {
      this.isTimezoneAuto = false;
      this.saveTimezone(false);
    }
  }
}
